import { useOutletContext } from 'react-router-dom';
import { withSclaCohortYear } from 'utils/navigation';
import { SclaApplicationOutletContext } from '../routes/SclaAppLayout';

export default function useSclaSectionPath() {
  const { readOnly, cohortYear } = useOutletContext<SclaApplicationOutletContext>();
  return (path: string) =>
    readOnly ? withSclaCohortYear(path, cohortYear) : path;
}
